import { useCallback, useState } from "react";
import { BlockProps } from "../types";
import { useBlock } from ".";

export interface UseEligibilityBlockArgs extends BlockProps {}

export const useEligibilityBlock = (args: UseEligibilityBlockArgs) => {
  const block = useBlock({ ...args, type: "eligibility.eligibility", select: (enduser) => enduser });

  const [showSubmissionForm, setShowSubmissionForm] = useState(false);

  const openSubmissionForm = useCallback(() => setShowSubmissionForm(true), []);
  const closeSubmissionForm = useCallback(() => setShowSubmissionForm(false), []);

  const enduser = block.enduserQuery.data;
  const hasInsurance = !!(enduser?.insurance || enduser?.insuranceSecondary);

  return {
    ...block,
    enduser,
    hasInsurance,
    showSubmissionForm,
    openSubmissionForm,
    closeSubmissionForm,
  };
};
